import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button
} from '@mui/material'
import React from 'react'
interface Props {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  title?: string
  message?: string
  cancelBtn?: string
  acceptBtn?: string
}
const CustomConfirmAlert: ReactFC<Props> = (props) => {
  return (
    <Dialog
      open={props.isOpen}
      onClose={() => {
        props.onClose()
      }}
    >
      <DialogTitle id='alert-dialog-title'>{props.title}</DialogTitle>
      <DialogContent>
        <DialogContentText id='alert-dialog-description'>
          {props.message}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            props.onClose()
          }}
        >
          {props.cancelBtn}
        </Button>
        <Button
          onClick={() => {
            props.onConfirm()
          }}
        >
          {props.acceptBtn}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
export default CustomConfirmAlert
